import {
  jb_language_alert_css_default
} from "./chunk.FDMZWKDM.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-language-alert/jb-language-alert.ts
var JbLanguageAlert = class extends i {
  constructor() {
    super(...arguments);
    this.displayDuration = 4e3;
    this.text = "";
    this._isVisible = false;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("text") && this.text) {
      this._section.setAttribute("role", "alert");
      this._isVisible = true;
      setTimeout(() => {
        this._isVisible = false;
        this._section.removeAttribute("role");
      }, this.displayDuration);
    }
  }
  render() {
    const classes = {
      hidden: !this._isVisible
    };
    return b`
      <section
        class="${e2(classes)}"
        data-nosnippet
      >
        <p>${o(this.text)}</p>
      </section>
    `;
  }
};
JbLanguageAlert.styles = [reset_css_default, jb_language_alert_css_default];
__decorateClass([
  n({ type: Number })
], JbLanguageAlert.prototype, "displayDuration", 2);
__decorateClass([
  n({ type: String })
], JbLanguageAlert.prototype, "text", 2);
__decorateClass([
  r()
], JbLanguageAlert.prototype, "_isVisible", 2);
__decorateClass([
  e("section")
], JbLanguageAlert.prototype, "_section", 2);
JbLanguageAlert = __decorateClass([
  customElement("jb-language-alert")
], JbLanguageAlert);

export {
  JbLanguageAlert
};
